module.exports = __webpack_public_path__ + "static/9-e019e95701c358f10bf24977364ac625.jpg";